module.exports = __webpack_public_path__ + "static/media/icon-piece7-6.a0c1f922.png";